import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../redux/store'; 
import { UserGroup } from "../../../../redux/models/userGroup.model";
import { updateUserGroup } from "../../../../redux/actions/userGroups.actions";
import ModalShell from "../../../../components/common/Modals/ModalShell";

interface ModalProps {
    isOpen: boolean, 
    setOpen: any,
    userGroup: UserGroup,
    params: string;
}

const UpdateUserGroupModal: React.FC<ModalProps> = ({isOpen, setOpen,userGroup,params}) => {
    const dispatch = useDispatch<AppDispatch>();
    const { accessToken } = useSelector((state: RootState) => state.user);
    const {data, loading, error} = useSelector((state: RootState) => state.userGroup);

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [submitted, setSubmitted] = useState(false);
  
      useEffect(() => {
        if (userGroup) {
          setName(userGroup.name);
          setDescription(userGroup.description);
        }
      }, [userGroup]);
  
    const handleSubmit = async (event: React.FormEvent) => {
      setSubmitted(true);
      await dispatch(updateUserGroup({id:userGroup.id, name:name, description:description}));

    };

    const handleClose = () => {
      handleReset();
      setOpen(false);
    };

    const handleReset = () => {
      setName('');
      setDescription('');
      setSubmitted(false);
    };

  const showForm = !submitted || loading;

  return (
    <ModalShell
      open={isOpen}
      onClose={handleClose}
      size={showForm ? "md" : "sm"}
      busy={submitted && loading}
      tone={showForm ? undefined : error ? "error" : "success"}
      title={showForm ? "Update user group" : error ? "An error occurred" : "User group updated"}
      actions={showForm ?
        <>
          <button className="btn" onClick={handleClose} disabled={submitted && loading}>Cancel</button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={loading || !accessToken}>
            {loading ? "Updating…" : "Update"}
          </button>
        </>
        : error ?
        <>
          <button className="btn" onClick={handleClose}>Close</button>
          <button className="btn btn-primary" onClick={handleReset}>Try again</button>
        </>
        :
        <button className="btn btn-primary" onClick={handleClose}>OK</button>
      }
    >
      {showForm ?
        <>
          <div className="field">
            <label className="field-label" htmlFor="name">Name</label>
            <input
              id="name"
              className="input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              disabled={loading}
              autoComplete="off"
            />
          </div>

          <div className="field">
            <label className="field-label" htmlFor="description">Description</label>
            <textarea
              id="description"
              className="input"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={4}
              required
              disabled={loading}
              autoComplete="off"
              style={{ resize: 'vertical' }}
            />
          </div>
        </>
        : error ?
        <p>{error}</p>
        :
        <p>{data.message}</p>
      }
    </ModalShell>
  );
};

export default UpdateUserGroupModal;
